/*
 * Decides the page language before anything renders. Imported first in
 * index.js, so i18n and every component read the same value.
 *
 * The URL wins: /Avocats/… is French, /محامي/… Arabic, /en is English. Only
 * pages whose URL carries no language (login, dashboards…) fall back to the
 * saved choice, then to the mobile app's French, then to Arabic.
 */
import urls from "@seo/urls";

function readSaved() {
  try {
    return localStorage.getItem("lang");
  } catch (e) {
    return null;
  }
}

function detectLang() {
  const fromUrl = urls.parsePath(window.location.pathname, window.location.search).lang;
  if (fromUrl) return fromUrl;
  const saved = readSaved();
  if (urls.LANGS.includes(saved)) return saved;
  if (navigator.userAgent === "AvoconsulteApp") return "fr";
  return "ar";
}

export const lang = detectLang();

try {
  localStorage.setItem("lang", lang);
} catch (e) {
  // Private mode: the language still comes from the URL on every page.
}
document.documentElement.lang = lang;
document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";

/**
 * The template ships one stylesheet per direction. Start fetching the right
 * one now; index.js renders once it has applied so React never paints
 * unstyled. Named chunks (style-ltr / style-rtl) so their files are easy to
 * find in dist/assets.
 */
export const stylesReady = (lang === "ar"
  ? import(/* webpackChunkName: "style-rtl" */ "../../assets/style-rtl.scss")
  : import(/* webpackChunkName: "style-ltr" */ "../../assets/style.scss")
).catch(() => null);
